import {Component, OnInit} from "@angular/core";

@Component({
    selector: 'footer-component',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
	ngOnInit(): void {
	}
}

